const initRankMathFAQ = () => {
  const questions = document.querySelectorAll(".rank-math-question");

  if (questions.length === 0) {
    return false;
  }

  questions.forEach((question) => {
    // Éviter de dupliquer les event listeners
    if (question.dataset.faqInitialized) {
      return;
    }
    question.dataset.faqInitialized = "true";

    question.addEventListener("click", () => {
      const item = question.closest(".rank-math-list-item");
      if (item) {
        item.classList.toggle("is-open");
      }
    });
  });

  return true;
};

// Initialiser le MutationObserver pour détecter l'injection dynamique du contenu
const setupObserver = () => {
  if (!document.body) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const hasRankMath = Array.from(mutation.addedNodes).some((node) => {
          return (
            node.nodeType === 1 &&
            (node.id === "rank-math-rich-snippet-wrapper" ||
              node.querySelector?.("#rank-math-rich-snippet-wrapper"))
          );
        });

        if (hasRankMath) {
          setTimeout(initRankMathFAQ, 100);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

const onReady = () => {
  initRankMathFAQ();
  setupObserver();

  // Fallback si le contenu n'est pas encore chargé
  setTimeout(() => {
    const wrapper = document.querySelector("#rank-math-rich-snippet-wrapper");
    if (
      wrapper &&
      !wrapper.querySelector(".rank-math-question[data-faq-initialized]")
    ) {
      initRankMathFAQ();
    }
  }, 500);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onReady);
} else {
  onReady();
}

// Fallback final
window.addEventListener("load", () => {
  const wrapper = document.querySelector("#rank-math-rich-snippet-wrapper");
  if (
    wrapper &&
    !wrapper.querySelector(".rank-math-question[data-faq-initialized]")
  ) {
    initRankMathFAQ();
  }
});
